import React, { useMemo } from 'react';
import { useController } from 'react-hook-form';
import { Skin } from '../../../declarations/models/Skin';
import { useEditorData } from '../../lib/components/EditorDataProvider';
import { Page } from '../../../declarations/models/Page';
import { SettingsComponent } from '../../lib/declarations/EditorComponentTypes';
import SkinSelector from '../../lib/components/settings/SkinSelector';
import { useCurrentSection } from '../CurrentSectionProvider';

export const PageSectionSkinSettings: SettingsComponent = () => {
  const { sectionPath } = useCurrentSection();
  const { skins } = useEditorData();

  const availableSkins = useMemo<Array<Skin>>(() => {
    return skins?.filter((skin) => skin.scope?.includes('grid') !== false);
  }, [skins]);

  const {
    field: { value: skinClass, onChange: setSkinClass },
  } = useController<Page, `${typeof sectionPath}.skin`>({ name: `${sectionPath}.skin` });

  const selectedSkin = useMemo<Skin | null>(() => {
    return availableSkins.find((skin) => skin.class === skinClass) || null;
  }, [availableSkins, skinClass]);

  const handleSkinChanged = (skin: Skin | null) => {
    setSkinClass(skin?.class || '');
  };

  return <SkinSelector availableSkins={availableSkins} selectedSkin={selectedSkin} onSkinChange={handleSkinChanged} />;
};

export default PageSectionSkinSettings;
